<template>
    <v-card>
        <v-card-text class="text-center pa-7" v-if="!loaded">
            <v-progress-circular
                indeterminate
                color="indigo"
                class="ma-5"
            ></v-progress-circular>
        </v-card-text>
        <v-card-text v-else>
            <chart
                width="100%"
                height="200"
                type="line"
                :options="options"
                :series="series"
            ></chart>
        </v-card-text>
    </v-card>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['resellerTypeRefer'],

    components: {
        chart: VueApexCharts,
    },

    data: () => {
        return {
            loaded: false,
            labels: [],
            columns: [],
            line: [],
        }
    },

    watch: {
        resellerTypeRefer() {
            this.loaded = false
            this.fetchCancellations().then(() => (this.loaded = true))
        },
    },

    computed: {
        series() {
            return [
                {
                    name: 'Faturamento',
                    type: 'column',
                    data: this.columns,
                },
                {
                    name: 'Quantidade',
                    type: 'line',
                    data: this.line,
                },
            ]
        },

        options() {
            return {
                chart: {
                    type: 'line',
                },
                stroke: {
                    width: [0, 4],
                },
                title: {
                    text: 'Cancelamentos',
                    style: {
                        fontSize: '24px',
                        fontFamily: 'Montserrat", sans-serif',
                        fontWeight: 600,
                    },
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1],
                },
                tooltip: {
                    x: {
                        format: 'MM/yyyy',
                    },
                    y: {
                        formatter: (value, ctx) => {
                            if (ctx.seriesIndex == 0)
                                return this.$n(value, 'currency')
                            return value
                        },
                    },
                },
                labels: this.labels,
                xaxis: {
                    type: 'datetime',
                },
                yaxis: [
                    {
                        title: {
                            text: 'Faturamento',
                            style: {
                                fontSize: '18px',
                                fontWeight: 400,
                            },
                        },
                    },
                    {
                        opposite: true,
                        title: {
                            text: 'Quantidade',
                            style: {
                                fontSize: '18px',
                                fontWeight: 400,
                            },
                        },
                    },
                ],
            }
        },
    },

    methods: {
        async fetchCancellations() {
            let endpoint =
                '/dashboard/kpis/monthly?which[]=cancellations.revenue&which[]=cancellations.count'
            if (this.resellerTypeRefer) {
                endpoint +=
                    '&aggregators[reseller_type_refer]=' +
                    this.resellerTypeRefer
            }
            let res = await this.$http.get(endpoint)
            this.dataHandler(res.data)
        },

        dataHandler(data) {
            let columns = []
            let line = []

            this.labels = Object.keys(data)
            this.labels.forEach(element => {
                columns.push(data[element]['cancellations.revenue'])
                line.push(data[element]['cancellations.count'])
            })

            this.columns = columns
            this.line = line
        },
    },

    created() {
        this.fetchCancellations().then(() => (this.loaded = true))
    },
}
</script>

<style></style>
